import '../../style/index.less';
import './index.less';



// WEBPACK FOOTER //
// ./components/icon-svg/style/index.tsx